import { NgModule } from "@angular/core";

import { TaskRoutingModule } from "./task-routing.module";
import { AddtaskComponent } from "./addtask/addtask.component";
import { DetailtaskComponent } from "./detailtask/detailtask.component";
import { EdittaskComponent } from "./edittask/edittask.component";
import { TaklistComponent } from "./taklist/taklist.component";

import { SharedModule } from "../../shared/shared.module";

@NgModule({
  declarations: [
    AddtaskComponent,
    EdittaskComponent,
    DetailtaskComponent,
    TaklistComponent,
  ],
  imports: [
    TaskRoutingModule,
    SharedModule,
  ],
})
export class TaskModule {}
